import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ItemManagement16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.5304 7.03026L7.50006 11.0606L4.96973 8.53026L6.03039 7.4696L7.50006 8.93927L10.4697 5.9696L11.5304 7.03026Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.98936 1.25C5.10518 0.67944 5.60962 0.25 6.21436 0.25H9.71436C10.3191 0.25 10.8235 0.67944 10.9394 1.25H13C13.6904 1.25 14.25 1.80964 14.25 2.5V13.5C14.25 14.1904 13.6904 14.75 13 14.75H3C2.30964 14.75 1.75 14.1904 1.75 13.5V2.5C1.75 1.80964 2.30964 1.25 3 1.25H4.98936ZM4.96436 2.75H3.25V13.25H12.75V2.75H10.9644V3C10.9644 3.69036 10.4047 4.25 9.71436 4.25H6.21436C5.524 4.25 4.96436 3.69036 4.96436 3V2.75ZM6.46436 1.75V2.75H9.46436V1.75H6.46436Z'
      fill='currentColor'
    />
  </Svg>
);

ItemManagement16.displayName = 'ItemManagement16';
export default ItemManagement16;
